// extracted by mini-css-extract-plugin
module.exports = {"container":"productReview_container__Yeae0","comments":"productReview_comments__ifEVe","summary":"productReview_summary__G55Yn"};